import { useTranslation } from "next-i18next"

const useMyServicei18n = ({ componentProps }) => {
  const { t } = useTranslation()
  const i18n = {
    newToOld: t("kf.myProducts.sort.newToOld"),
    oldToNew: t("kf.myProducts.sort.oldToNew"),
    AToZ: t("kf.services.sort.AToZ"),
    ZToA: t("kf.services.sort.ZToA"),
    myServices: t("kf.services.label.myServices"),
    sort: t("kf.services.label.sortBy"),
    sortbyExpanded: t("kf.plp.label.sortbyExpanded"),
    sortbyClosed: t("kf.plp.label.sortbyClosed"),
    selected: t("kf.plp.arialabel.selected"),
    altSort: t("kf.plp.label.img.altSort"),
    activeServices: t("kf.services.label.activeServices"),
    noServices: t("kf.services.label.noServices"),
    continueShopping: t("kf.services.label.continueShopping"),
    pastServices: t("kf.services.label.pastServices"),
    completedServices: t("kf.services.label.completedServices"),
    sortByAria: count => t("kf.plp.label.sortByAria", { sortByCount: count }),
    hi: t("kf.account.label.hi"),
    signOut: t("kf.account.label.signOut"),
    myAccount: t("kf.account.label.myAccount"),
    favorites: t("kf.account.label.favorites"),
    accountSettings: t("kf.account.label.accountSettings"),
    orders: t("kf.account.label.orders"),
    myProducts: t("kf.account.label.myProducts"),
    myServices: t("kf.account.label.myServices"),
    shopServices: t("kf.services.label.shopServices"),
  }

  return i18n
}

export default useMyServicei18n
